<lxm-dialog [dialogRef]="dialogRef" [formGroup]="form" #dialog>
  <span header-title>{{(isNew ? 'cards.products.product_store_schemes.edit.title_new' :
    'cards.products.product_store_schemes.edit.title') | translate}}</span>
  <div body>
    <form-field [label]="'table.valid_from' | translate" [required]="true">
      <lxm-datepicker combined class="dialog-input-fixed-width-1" for="validFrom" [min]="minDate"></lxm-datepicker>
      <validation-errors for="validFrom"></validation-errors>
    </form-field>

    <form-field [label]="'cards.products.product_store_schemes.table.visible_in_store' | translate"
      [description]="'cards.products.product_store_schemes.edit.label_description.visible_in_store' | translate">
      <slide-toggle toggle for="retailersListIsExclusive"></slide-toggle>
      <validation-errors for="retailersListIsExclusive"></validation-errors>
    </form-field>

    <form-field [label]="form.get('retailersListIsExclusive').value
      ? 'cards.products.product_store_schemes.edit.label.exclusive_retailers'
      : 'cards.products.product_store_schemes.edit.label.inclusive_retailers'" [description]="form.get('retailersListIsExclusive').value
      ? 'cards.products.product_store_schemes.edit.label_description.exclusive_retailers'
      : 'cards.products.product_store_schemes.edit.label_description.inclusive_retailers'">
      <lxm-select select class="w-full" labelField="name" [multiple]="true" [options]="retailChains" value="id"
        for="retailers" [searchable]="true" [sortByLabel]="true"></lxm-select>
      <validation-errors for="retailers"></validation-errors>
      <validation-errors for="retailerIds"></validation-errors>
    </form-field>

    <span class="separator"></span>

    <form-field [label]="'cards.products.product_store_schemes.table.store_category' | translate" [required]="true">
      <lxm-select for="storeCategoryId" [options]="categoryOptions" labelField="name" value="id" [sortByLabel]="true"
        [clearable]="false" [searchable]="true"></lxm-select>
    </form-field>

    <form-field *ngIf="appState.hasModule(LxmAppModule.WarehouseTypes)"
      label="cards.products.product_base_info.label.warehouse_type"
      description="cards.settings.product_management_settings.warehouse_types_edit.info_text" for="warehouseTypeId"
      [required]="true">
      <lxm-select select labelField="value" [searchable]="true" for="warehouseTypeId" value="id"
        [options]="warehouseTypes" [clearable]="false" [readonly]="true" [labelFn]="warehouseTypeLabel">
      </lxm-select>
      <validation-errors class="input-padding" for="warehouseTypeId"></validation-errors>
    </form-field>

    <form-field [label]="'cards.products.product_store_schemes.edit.label.product_unit_and_orderability' | translate"
      [required]="true">
      <div class="flex w-full flex-col">
        <table>
          <tbody>
            <tr class="cursor-pointer items-center justify-between gap-5 rounded-sm px-5x hover:bg-grey-10"
              *ngFor="let item of packagingData" (click)="openPackagingDialog(item)">
              <td class="w-full px-[10px] py-3">{{item.type | systemClvName | formValue }}</td>
              <td class="px-[10px] py-3" [ngSwitch]="item.isOrderUnit">
                <div class="flex flex-1 items-center gap-2 whitespace-nowrap">
                  <ng-container *ngSwitchCase="true">
                    <svg-icon key="success" fontSize="14px"></svg-icon>
                    <span>{{ 'cards.products.product_store_schemes.edit.label.is_orderable' | translate }}</span>
                  </ng-container>
                  <ng-container *ngSwitchCase="false">
                    <svg-icon key="xRed14" fontSize="14px"></svg-icon>
                    <span>{{ 'cards.products.product_store_schemes.edit.label.is_not_orderable' | translate }}</span>
                  </ng-container>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <validation-errors for="productUnits" class="p-[var(--table-cell-padding)]"></validation-errors>
      </div>
    </form-field>
  </div>

  <div footer class="justify-between">
    <div class="flex flex-row">
      <lxm-button type="orange" label="action.save" [loading]="actionLoading.save" (click)="save()"
        buttonType="submit"></lxm-button>
      <lxm-button type="grey" class="ml10" label="action.cancel" (click)="closeDialog()"></lxm-button>
    </div>

    <div class="flex flex-row">
      <lxm-button *ngIf="data.schema?.id" type="transparent" label="action.delete" icon="trash" class="ml30"
        (click)="deleteScheme()"></lxm-button>
    </div>
  </div>
</lxm-dialog>